// extracted by mini-css-extract-plugin
export default {"root":"_2u1Ro"};